import NumberFormatLib from 'react-number-format'
import React from 'react'

interface NumberFormatCustomProps {
  // @ts-ignore
  inputRef: (instance: NumberFormatLib | null) => void
  onChange: (event: { target: { name: string; value: string } }) => void
  name: string
  [key: string]: any
}

export const NumberFormat = (props: NumberFormatCustomProps) => {
  const { inputRef, onChange, ...other } = props

  return (
    <NumberFormatLib
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        })
      }}
      thousandSeparator=","
      decimalSeparator="."
      isNumericString
    />
  )
}
